__turbopack_context__.v({
  "controlGroup": "Shop2-module__yt6iya__controlGroup",
  "controls": "Shop2-module__yt6iya__controls",
  "filterControl": "Shop2-module__yt6iya__filterControl",
  "pcImg": "Shop2-module__yt6iya__pcImg",
  "pcImgWrapper": "Shop2-module__yt6iya__pcImgWrapper",
  "productInfo": "Shop2-module__yt6iya__productInfo",
  "productList": "Shop2-module__yt6iya__productList",
  "productLoadingBox": "Shop2-module__yt6iya__productLoadingBox",
  "productLoadingSpinner": "Shop2-module__yt6iya__productLoadingSpinner",
  "productLoadingText": "Shop2-module__yt6iya__productLoadingText",
  "productSpin": "Shop2-module__yt6iya__productSpin",
  "productTitle": "Shop2-module__yt6iya__productTitle",
  "swiperContainer": "Shop2-module__yt6iya__swiperContainer",
});
